/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { HeatSeries } from "src/store/api/generatedApi";
import { NumberSerialiserOptions } from "hooks/serialisers/types";
import { Box, useTheme } from "@mui/material";
import {
  calculateOpacity,
  formatDiffValue,
  getBaseColor,
  getSourceValue,
} from "../utils";
import { roundToDecimalPlaces } from "hooks/serialisers/numbers";
import { useState } from "react";

export const TotalCostDiffCell = ({
  row,
  sources,
  selectedSummaryName,
  ignoredMaterials,
  formatNumber,
}: {
  row: HeatSeries;
  sources: string[];
  selectedSummaryName: string | null;
  ignoredMaterials: Set<string>;
  formatNumber: (value: number, options?: NumberSerialiserOptions) => string;
}) => {
  const [isHovering, setIsHovering] = useState(false);
  const theme = useTheme();
  if (!selectedSummaryName || sources.length < 2) return null;

  let firstValue = null;
  let lastValue = null;

  for (const source of sources) {
    const value = getSourceValue(
      source,
      row.mixes,
      selectedSummaryName,
      ignoredMaterials
    );
    firstValue ??= value;
    lastValue = value;
  }

  const difference = roundToDecimalPlaces(
    (lastValue?.value ?? 0) - (firstValue?.value ?? 0),
    lastValue?.decimalPlaces ?? 0
  );

  if (firstValue === null || lastValue === null)
    return (
      <Box
        sx={{
          ...theme.typography.body2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          fontWeight: "fontWeightMedium",
        }}
      >
        -
      </Box>
    );
  if (firstValue.value === 0 && lastValue.value === 0) return null;

  const formattedDiff = formatDiffValue(
    difference,
    formatNumber,
    lastValue?.decimalPlaces ?? 0
  );
  const diffColor = getBaseColor(difference, selectedSummaryName, theme);
  const opacity = calculateOpacity(difference, lastValue?.value ?? null);

  return (
    <Box
      sx={{
        ...theme.typography.body2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        fontWeight: "fontWeightMedium",
        color: diffColor,
        opacity: isHovering ? 1 : opacity,
      }}
      onMouseEnter={() => {
        setIsHovering(true);
      }}
      onMouseLeave={() => {
        setIsHovering(false);
      }}
    >
      {formattedDiff}
    </Box>
  );
};
